<template>
  <v-tabs-items :value="currentTab" @change="updateTab" class="products">
    <v-tab-item
      v-for="(_, collectionIndex) in products.length"
      :key="collectionIndex"
    >
      <div v-if="!products[collectionIndex]" class="skleton-view">
        <ProductCardSkeleton class="mb-4" v-for="n in 3" :key="n" />
      </div>
      <div
        class="text-center"
        v-else-if="products[collectionIndex].length === 0"
      >
        <span class="text-caption"
          >No tickets in this section! Oh the sadness :')</span
        >
      </div>
      <div v-else-if="products[collectionIndex]" class="products-container">
        <ProductCard
          class="mb-4"
          v-for="(product, index) in products[collectionIndex]"
          :key="index"
          :product="product"
        />
      </div>
      <span v-else>Loading</span>
    </v-tab-item>
  </v-tabs-items>
</template>

<style lang="scss">
.products {
  overflow-y: scroll;
}

.products-container {
  max-height: calc(5 * 130px); // 5 cards * (106px image + 24px padding + margin)
  overflow-y: auto;
  padding-right: 8px; // Space for scrollbar
  
  &::-webkit-scrollbar {
    width: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 2px;
    
    &:hover {
      background: #a8a8a8;
    }
  }
}
</style>

<script lang="ts">
import Vue from 'vue'
import Options from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import ProductCard from '@/components/ProductCard.vue'
import ProductCardSkeleton from '@/components/ProductCardSkeleton.vue'

import { SET_CURRENT_TAB } from '../store/types'
import { CollectionProduct } from '@/utils/shopify'

@Options({
  components: {
    ProductCard,
    ProductCardSkeleton,
  },
  computed: {
    ...mapGetters([
      'currentTab',
      'numberOfCollections',
      'products',
      'tag',
      'isCollectionsLoaded'
    ]),
  }
})
export default class Products extends Vue {
  currentTab!: number
  products!: CollectionProduct[]
  isCollectionsLoaded!: boolean
  tag!: string | null
  numberOfCollections!: number

  @Watch('isCollectionsLoaded', { immediate: true })
  onCollectionLoaded(newValue: number): void {
    if (newValue) {
      for(let i = 0; i < this.numberOfCollections; i++) {
        this.$store.dispatch('loadProducts', i)
      }
    }
  }

  updateTab(newTab: number): void {
    this.$store.commit(SET_CURRENT_TAB, newTab)
  }
}
</script>
